export var Operator;
(function (Operator) {
    Operator[Operator["NOT_EMPTY"] = 1] = "NOT_EMPTY";
    Operator[Operator["EQUAL"] = 2] = "EQUAL";
    Operator[Operator["GREATER_THAN"] = 3] = "GREATER_THAN";
    Operator[Operator["SMALLER_THAN"] = 4] = "SMALLER_THAN";
    Operator[Operator["CONTAINS"] = 5] = "CONTAINS";
    Operator[Operator["NOT_EQUAL"] = 6] = "NOT_EQUAL";
    Operator[Operator["DOES_NOT_CONTAIN"] = 7] = "DOES_NOT_CONTAIN";
})(Operator || (Operator = {}));
// value should be the value of the field that is depended on
// targetValue is the value that is set in typo3
export const meetsCondition = (value, operator, targetValue) => {
    if (Array.isArray(value)) {
        return value.some((value) => meetsCondition(value, operator, targetValue));
    }
    switch (operator) {
        case Operator.NOT_EMPTY:
            return value !== '';
        case Operator.EQUAL:
            return value === targetValue;
        case Operator.GREATER_THAN:
            return parseInt(value) > parseInt(targetValue);
        case Operator.SMALLER_THAN:
            return parseInt(value) < parseInt(targetValue);
        case Operator.CONTAINS:
            return value ? value.toLowerCase().includes(targetValue.toLowerCase()) : false;
        case Operator.NOT_EQUAL:
            return value !== targetValue;
        case Operator.DOES_NOT_CONTAIN:
            return !value.toLowerCase().includes(targetValue.toLowerCase());
        default:
            return false;
    }
};
